<template lang="html">
  <div>
    <div class="amenities-grid contained-height">
      <div class="slide-page container-fluid mt-5"
        v-for="(chunk, chunkIndex) in slideSplit"
        :class="{ active: pageIndex === chunkIndex }"
        :key="chunkIndex"
      >
        <div class="row">
          <div class="offset-1 col-10">
            <div class="row">
              <div class="grid-item my-3 col-4"
                v-for="(slide, index) in chunk"
                :key="slide.id"
              >
                <div class="grid-img p-3"
                  :style="{ backgroundImage: 'url(' + slide.src + ')'}"
                  @click="discoverLabelClicked((chunkIndex*9) + index)"
                >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div id="amenities-lightbox" class="position-absolute" v-show="showSlides">
        <div id="amenities-slides">
          <section-slides :slides="slides" ref="amenitiesSlides" />
        </div>
        <div class="amenities-close position-absolute" @click="showSlides = false;">
          <i class="fal fa-times-circle"></i>
        </div>
        <!-- <button class="btn btn-action btn-close mb-1"
        @click="closeamenitiesLightbox">close <i class="fal fa-times"></i></button> -->
      </div>
    </transition>
    <div class="neighbourhood-arrows position-absolute d-flex flex-row align-items-center justify-content-end">
        <div class="index pr-4">
          {{ pageIndex + 1 }} / {{ slideSplit.length || 0}}
        </div>
        <div class="arrow-container d-flex flex-row align-items-center justify-content-end">
          <div class="neighbourhood-arr d-flex flex-row align-items-center justify-content-center" @click="prevSlide()">
            <i class="fal fa-long-arrow-left"></i>
          </div>
          <div class="neighbourhood-arr d-flex flex-row align-items-center justify-content-center" @click="nextSlide()">
            <i class="fal fa-long-arrow-right"></i>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import SectionSlides from '@/components/SectionSlides';

function chunk(arr, n) {
  return arr.slice(0, ((arr.length + n - 1) / n) | 0).map((c, i) => arr.slice(n * i, n * i + n));
}

export default {
  data() {
    return {
      showSlides: false,
      curSlideIndex: 0,
      pageIndex: 0
    };
  },
  computed: {
    ...mapState({
      slides: state => state.amenities.slides
    }),
    slideSplit() {
      const newArr = chunk(
        this.slides,
        Math.floor(9)
      );
      return newArr;
    }
  },
  methods: {
    ...mapMutations({
      setPageReady: 'ui/setPageReady'
    }),
    discoverLabelClicked(index) {
      const amenitiesSlides = this.$refs.amenitiesSlides;
      this.showSlides = true;
      amenitiesSlides.setSlide(index);
    },
    prevSlide() {
      this.pageIndex -= 1;
      if (this.pageIndex < 0) {
        this.pageIndex = this.slideSplit.length - 1;
      }
    },
    nextSlide() {
      this.pageIndex += 1;
      if (this.pageIndex === this.slideSplit.length) {
        this.pageIndex = 0;
      }
    }
  },
  mounted() {
    // if (!window.modelReady) {
    // window.modelReady = this.modelLoaded.bind(this);
    // }
    // window.discoverLabelClicked = this.discoverLabelClicked.bind(this);
    // window.triggerResize = this.resizeToFixModel.bind(this);
    this.setPageReady(true);
  },
  beforeDestroy() {
    window.modelReady = null;
    window.discoverLabelClicked = null;
    window.triggerResize = null;
    this.setPageReady(false);
  },
  components: {
    'section-slides': SectionSlides
  }
};
</script>

<style lang="scss" scoped>
.model-debug {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  color: black;
}

.interact-instructions {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.interact-instructions-text {
  width: 130px;
  position: relative;
  color: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: hsla(0, 0, 0, 0.8);
  border-radius: 0.25rem;
}

#amenities-lightbox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}

.amenities-grid {
  width: calc(1920px - #{$neighbourhoodNavWidth});
  margin-left: auto;
  margin-right: 0px;
  position: relative;
  // background-color: black;
  // height: 100%;
}

#amenities-slides {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: var(--background);
  padding-bottom: 50px;
}

.btn-close {
  position: absolute;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 999;
  color: var(--text);
  font-size: 0.8rem;

  &:hover {
    text-decoration: underline;
  }
}

.grid-item {
  height: 250px;
  width: calc(100% / 3);
  display: flex;

  .grid-img {
    width: 100%;
    height: 250px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
}

.slide-page {
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  position: absolute;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-out;

  &.active {
    opacity: 1;
    pointer-events: auto;
  }
}

.amenities-close {
  color: var(--branding);
  bottom: 110px;
  left: 30px;
  z-index: 5;
  i {
    font-size: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AmenitiesPage/pages/AmenitiesGalleryPage.vue